export const Error = (errors, errorName) => {
  if (errors !== null && errors.hasOwnProperty(errorName)) {
    return "error";
  }
};
